<template>
  <div class="container" style="min-width: 1100px">
    <p class="paraHead" style="font-size: 26px">盲人用户详情</p>
    <Card class="bodyCard">
      <Row :gutter="64">
        <Col span="3">
        <div style="width: 100px;height: 100px;background-color:#fff;">
          <img :src="blindUser.avatarUrl" alt="headUrl" style="width: 100px;height: 100px;"/>
        </div>
        </Col>
        <Col span="6">
        <p class="basicInfo">昵称:<span style="float: right;">{{blindUser.nickname}}</span></p>
          <p class="basicInfo">加入时间:<span style="float: right">{{blindUser.createDate}}</span></p>
        </Col>
        <Col span="7">
        <p class="basicInfo">提问数量:
          <span style="float: right;"><span class="answerInfo">{{blindUser.helpInfoCount}}</span>条</span>
        </p>
        <p class="basicInfo">城市:
          <span style="float: right;"><span class="answerInfo">{{blindUser.city}}</span></span>
        </p>
        <p class="basicInfo">性别:
          <span style="float: right;"><span class="answerInfo">{{blindUser.sex}}</span></span>
        </p>
        </Col>
        <Col span="7">
        <p class="basicInfo">便签:
          <span style="float: right;"><span class="answerInfo">{{blindUser.tag}}</span></span>
        </p>
        </Col>
      </Row>
    </Card>
    <p class="paraHead" style="font-size: 20px">提问历史</p>
    <Tabs value="totalMessage" style="margin: 25px;width: 95%;">
      <TabPane label="全部消息" name="totalMessage">
        <table class="fourDiv">
          <tr>
            <td style="text-align: center;width: 25%">
              <div class="innerDiv">
                <div class="divHead">
                  时间
                </div>
                <Button style="border:none;background-color:rgb(245,247,249);" class="btn" @click.native="getAllTime">
                <Radio v-model="totalTime" style="font-size: 14px;margin:5% 0 5% -20%;"  @on-change="">所有时间</Radio>
                </Button>
                <p style="font-size: 16px">最近&emsp;<span>
                <Select v-model="recentTime" style="width: 60%">
                    <Option v-for="timer in timeList" :value="timer.value" :key="timer.value">{{timer.label}}</Option>
                </Select></span></p>
                <DatePicker type="date" placeholder="起始时间" style="width: 80%;margin:5%" v-model="fromTime"></DatePicker>
                <p style="font-size: 16px;margin-left:-70%;">至</p>
                <DatePicker type="date" placeholder="结束时间" style="width: 80%;margin:5%" v-model="toTime"></DatePicker>
                <p style="margin:0 -50% 3% 0">设为默认&emsp;<i-switch v-model="switch1" @on-change="change1" /></p>
              </div>
            </td>
            <td style="text-align: center;width: 25%">
              <div class="innerDiv">
                <div class="divHead">
                  盲人评分
                </div>
                <Button style="border:none;background-color:rgb(245,247,249);" class="btn" @click.native="getAllRate">
                  <Radio v-model="totalRate" style="font-size: 14px;margin:5% 0 5% -50%;">所有评分</Radio>
                </Button>
                <CheckboxGroup v-model="rateArr">
                  <Checkbox class="pInCheck" label="5星"><Rate disabled v-model="rate5" /></Checkbox>
                  <Checkbox class="pInCheck" label="4星"><Rate disabled v-model="rate4" /></Checkbox>
                  <Checkbox class="pInCheck" label="3星"><Rate disabled v-model="rate3" /></Checkbox>
                  <Checkbox class="pInCheck" label="2星"><Rate disabled v-model="rate2" /></Checkbox>
                  <Checkbox class="pInCheck" label="1星"><Rate disabled v-model="rate1" /></Checkbox>
                  <Checkbox class="pInCheck" label="0星">未评价</Checkbox>
                </CheckboxGroup>
                <p style="margin:4% -50% 3% 0">设为默认&emsp;<i-switch v-model="switch2" @on-change="change2" /></p>
              </div>
            </td>
            <td style="text-align: center;width: 25%">
              <div class="innerDiv">
                <div class="divHead">
                  当前进度
                </div>
                <Button style="border:none;background-color:rgb(245,247,249);" class="btn" @click.native="getAllProcess">
                <Radio v-model="totalProcess" style="font-size: 14px;margin:5% 0 5% -20%;">所有进度</Radio>
              </Button>
                <CheckboxGroup v-model="processArr">
                  <Checkbox class="pInCheck" style="margin-top:2%" label="zero">&emsp;0人回复</Checkbox>
                  <Checkbox class="pInCheck" style="margin-top:2%" label="twenty">&emsp;25%回复</Checkbox>
                  <Checkbox class="pInCheck" style="margin-top:2%" label="fifty">&emsp;50%回复</Checkbox>
                  <Checkbox class="pInCheck" style="margin-top:2%" label="seventy">&emsp;75%回复</Checkbox>
                  <Checkbox class="pInCheck" style="margin-top:2%" label="hundred">&emsp;100%回复</Checkbox>
                  <Checkbox class="pInCheck" style="margin-top:2%" label="manager">&emsp;已有管理员回复</Checkbox>
                </CheckboxGroup>
                <p style="margin:2% -50% 2% 0">设为默认&emsp;<i-switch v-model="switch3" @on-change="change3" /></p>
              </div>
            </td>
            <td style="text-align: center;width: 25%">
              <div class="innerDiv">
                <div class="divHead">
                  求助方式
                </div>
                <CheckboxGroup v-model="wayArr">
                  <Checkbox class="pInCheck" style="margin-top:10%" label="picAndWord">图片&nbsp;+&nbsp;文字</Checkbox>
                  <Checkbox class="pInCheck" style="margin-top:10%" label="picAndVoice">图片&nbsp;+&nbsp;语音</Checkbox>
                  <hr style="width: 80%;margin:10% auto;border:1px solid #CCCCCC;">
                  <Checkbox class="pInCheck" label="shortVideo">短视频</Checkbox>
                </CheckboxGroup>
                <p style="margin:7% -50% 2% 0">设为默认&emsp;<i-switch v-model="switch4" @on-change="change4" /></p>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <hr style="width: 98%;margin:1% auto;border:1px solid #CCCCCC;">
            </td>
          </tr>
          <tr>
            <td colspan="4" style="text-align: center">
              <Button type="primary" style="width: 5%;margin:0 1% 1% 0" @click.native="resetAll">重置</Button>
              <Button type="primary" style="width: 5%;margin:0 0 1% 1%" @click.native="searchQus">筛选</Button>
            </td>
          </tr>
        </table>

        <div class="searchCard">
          <Row>
            <Col span="2">
            <Button type="primary" style="margin-left: 40%;margin-top: 1%" @click.native="searchItem">搜索</Button>
            </Col>
            <Col span="10">
            <Input type="text" placeholder="问题关键字" v-model="vitalWord" style="width: 50%" clearable @on-change="summaryChange" @on-enter="searchItem">
            <Button slot="append" icon="close-circled" style="border: none;" @click="clearInputInfo"></Button>
            </Input>
            </Col>
          </Row>
        </div>

        <Table stripe :columns="columns"
               :data="tableData"
               class="mainTable">
        </Table>
        <Page :total="dataCount"
              :page-size="pageSize"
              show-total
              class="paging"
              @on-change="changePage">
        </Page>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
  import { format, formatAskWay } from "../../utils/format.js";
  import { adminRouter } from "../../router/admin";
  // import Utils from '../../utils/util.js';
  export default {
    name: "blindDetail",
    data() {
      return {
        blindUser: {
          "avatarUrl": "",
          "nickname": "", //昵称
          "createDate": "", //加入时间
          "helpInfoCount": 0, //提问数量
          "city": "", //城市
          "sex": "", //性别
          "tag": ""//被提问数量
        },
        /*时间模块的相关参数*/
        totalTime:true, //所有时间单选按钮
        recentTime:"一周", //选择列表最近的时间
        timeList:[
          {
            value:'一天',
            label:'一天'
          },
          {
            value:'一周',
            label:'一周'
          },
          {
            value:'一月',
            label:'一月'
          },
          {
            value:'一年',
            label:'一年'
          }
        ],
        fromTime:"", //起始时间
        toTime:"", //结束时间
        switch1:true, //第一个设为默认

        /*盲人评分模块的相关参数*/
        totalRate:true, //所有评分单选按钮
        rate5:5,
        rate4:4,
        rate3:3,
        rate2:2,
        rate1:1,
        check:"",
        rateArr:['5星', '4星', '3星', '2星', '1星', '0星'], //获取盲人评分数组
        switch2:true, //第二个设为默认

        /*当前进度模块的相关参数*/
        totalProcess:true, //所有进度单选按钮
        processArr:['zero', 'twenty', 'fifty', 'seventy', 'hundred', 'manager'], //获取当前进度数组
        switch3:true, //第三个设为默认

        /*求助方式模块的相关参数*/
        wayArr:['picAndWord', 'picAndVoice', 'shortVideo'], //求助方式选项数组
        switch4: true,
        vitalWord: "", //搜索框的内容
        columns: [
          {
            title: 'ID',
            key: "id",
            align: 'center'
          }, {
            title: "求助时间",
            key: "updateTime",
            align: 'center',
            sortable: true,
            render: (h, params) => {
              return h("div", format(params.row.updateTime, "yyyy-MM-dd hh:mm"));
            }
          }, {
            title: "求助方式",
            key: "askWay",
            align: 'center',
            render:(h, params) => {
              return h('div', formatAskWay(params.row.askWay));
            }
          }, {
            title: "盲人昵称",
            key: "nickname",
            align: 'center'
          }, {
            title: "问题缩略",
            key: "helpText",
            align: 'center'
          }, {
            title: "当前进度",
            key: "process",
            align: 'center'
          }, {
            title: '详情',
            align: 'center',
            render: (h, params) => {
              return h('Button', {
                props: {
                  type: "primary",
                  icon: "ios-arrow-right"
                },
                style: {
                  border: 'none',
                  fontSize: "20px"
                },
                on: {
                  click:() => {
                    //转到求助消息详情页面
                    let id = parseInt(params.row.id);
                    let helpInfo = {};
                    let offerHelpInfos = [];
                    this.$http.post("/zm/help/getQuestionAndAnswer", {"id": id}).then(res => {
                        helpInfo = res.data.content.helpInfo;
                        offerHelpInfos = res.data.content.offerHelpInfos;
                        if (!helpInfo.openid) {
                          this.$Message.error("获取信息失败");
                          return;
                        }
                        let active = "helpMessageManage";     //下个版本更新url
                        this.$http.post("/zm/backManage/queryAllQuestionsByOpneid", {
                          "content": {},
                          "openid": helpInfo.openid
                        }).then(res => {
                            if (this.currentTag !== active) {
                              let tags = null;
                              for (let ele of adminRouter) {
                                if (ele.name === active) {
                                  tags = {
                                    title: ele.title,
                                    name: ele.name,
                                    path: ele.path
                                  };
                                  break;
                                } else {
                                  if (ele.children.length) {
                                    for (let val of ele.children) {
                                      if (val.name === active) {
                                        tags = {
                                          title: val.title,
                                          name: val.name,
                                          path: val.path
                                        };
                                        break;
                                      }
                                    }
                                  }
                                }
                              }
                              localStorage.setItem("currentTag", active);
                              this.$store.commit("updateCurrentTag", active);
                              this.$store.commit("updateOpenedTags", [tags]);
                              this.$store.commit("updateCurrentPath", active);
                              Object.assign(helpInfo, res);
                              this.$router.push({
                                name: "helpMessageManage",
                                params: {
                                  "helpInfo": helpInfo,
                                  "offerHelpInfos": offerHelpInfos
                                }
                              });
                            }
                          },
                          err => {
                            this.$Message.error("请求失败：" + err.message);
                          });
                      });
                  }
                }
              });
            }
          }
        ],
        dataCount:0, //初始化信息总条数
        pageSize:20, //每页条数
        tableLoading:false, //表格是否加载
        dataSearch://请求的数据
          {
            "code": 0,
            "content": {},
            "currPage": 1,
            "pageSize": 20,
            "pageTotal": 0
          },
        tableData: []
      };
    },
    destroyed(){
      this.$router.go(-1);
    },
    methods: {
      // functionA(){ //调用menu-list的函数用于切换页面
      //   Utils.$emit('demo', 'helpMessageManage');
      // },
      change1() { //第一个设为默认
        if (this.switch1) {
          this.totalTime = true;
          this.recentTime = "一周";
          this.fromTime = "";
          this.toTime = "";
        } else {
          this.totalTime = false;
        }
      },
      change2(){ //第二个设为默认
        if(!this.switch2) {
          this.totalRate=false;
          this.rateArr=[];
        }else{
          this.rateArr=['5星', '4星', '3星', '2星', '1星', '0星'];
          this.totalRate=true;
        }
      },
      change3(){ //第三个设为默认
        if(!this.switch3){
          this.totalProcess=false;
          this.processArr=[];
        }else{
          this.totalProcess=true;
          this.processArr=['zero', 'twenty', 'fifty', 'seventy', 'hundred', 'manager'];
        }
      },
        change4(){
        if(!this.switch4){
          this.wayArr=[];
        }else {
          this.wayArr=['picAndWord', 'picAndVoice', 'shortVideo'];
        }
      },
      getAllTime(){ /*所有时间单选按钮*/
          this.totalTime=!this.totalTime;
          if(!this.totalTime){
            this.switch1=false;
          }
      },
      getAllRate(){ /*点击所有评分*/
        if(!this.totalRate) {
          this.totalRate=true;
          this.rateArr=['5星', '4星', '3星', '2星', '1星', '0星'];
          this.switch2=true;
        } else {
          this.totalRate=false;
          this.rateArr=[];
          this.switch2=false;
        }
      },
      getAllProcess(){ /*点击所有进度*/
        if(!this.totalProcess){
          this.totalProcess=true;
          this.processArr=['zero', 'twenty', 'fifty', 'seventy', 'hundred', 'manager'];
          this.switch3=true;
        }else{
          this.totalProcess=false;
          this.processArr=[];
          this.switch3=false;
        }
      },
      resetAll(){ //重置
        this.switch1=true;
        this.switch2=true;
        this.switch3=true;
        this.switch4=true;
        this.change1();
        this.change2();
        this.change3();
        this.change4();
      },
      searchQus(){ //筛选
        console.log("选择列表最近的时间   :"+this.recentTime);
        console.log("起始时间  :"+this.fromTime);
        console.log("结束时间   :"+this.toTime);
        console.log("盲人评分数组   :"+this.rateArr);
        console.log("当前进度数组   :"+this.processArr);
        console.log("求助方式数组   :"+this.wayArr);
      },
      clearInputInfo(){ //清除搜索框的内容
        this.vitalWord="";
      },
      summaryChange(){ //搜索框中的内容改变触发
        if(this.vitalWord===""){
          delete this.dataSearch.content["helpText"];
        }else {
          this.dataSearch.content.helpText=this.vitalWord;
        }
      },
      searchItem(){ //点击搜索
        this.tableLoading = true;
        this.dataSearch.currPage = 1;
        this.currPage = 1;
        let openId=this.$route.query.openId;
        this.$http.post('/zm/backManage/queryAllQuestionsByOpenid?openid='+openId, this.dataSearch).then(
          res => {
            this.tableData=res.data.content;
            this.dataCount=res.data.pageTotal;
            this.pageSize=res.data.pageSize;
            this.$data.tableLoading = false;
          }
          );
      },
      changePage(index){ //改变页数
        this.dataSearch.currPage=index;
        // console.log(this.dataSearch);
        let openId=this.$route.query.openId;
        this.tableLoading=true;
        this.$http.post('/zm/backManage/queryAllQuestionsByOpenid?openid='+openId, this.dataSearch).then(res => {
            this.tableData = res.data.content;
            this.dataCount=res.data.pageTotal;
            this.pageSize=res.data.pageSize;
            this.tableLoading=false;
          }
          );
      },
      getData(){ //获取数据
        let id=this.$route.query.id;
        let openId=this.$route.query.openId;
        // console.log(id);
        // console.log(openId);
        this.$http.post('/zm/backManage/queryAskerInfoDetail?id='+id+'&openid='+openId).then(res => {
          this.blindUser=res.data.content;

            this.dataSearch.content={"openid":openId};//修改传回去的参数
            /*获取这个盲人提问的所有问题*/
            this.$http.post('/zm/backManage/queryAllQuestionsByOpenid?openid='+openId, this.dataSearch).then(
              res => {
                this.tableData=res.data.content;
                this.dataCount=res.data.pageTotal;
                this.pageSize=res.data.pageSize;
              });
        },
          err => {
            this.$Message.error("请求失败：" + err.message);
            this.tableLoading = false;
          });
      }
    },
    watch: {
    },
    activated(){
      this.getData();
    },
    mounted(){
    }
  };
</script>

<style scoped>
  .paraHead {
    font-size: 20px;
    margin-left: 25px;
    margin-top: 25px;
  }
  .bodyCard {
    margin-left: 25px;
    width: 95%;
    border-radius: 10px;
    background-color: rgba(229, 229, 229, 1);
    margin-top: 10px;
  }
  .basicInfo {
    font-size: 18px;
    margin-top: 10px;
    margin-left: 20px;
  }
  .answerInfo {
    color: rgba(42, 130, 228, 1);
  }
  .fourDiv{/*4个div所在的表格*/
    border:2px solid #CCCCCC;
    border-radius:5px;
    width: 100%;
    height: 20%;
  }
  .innerDiv{/*表格内的div*/
    border:2px solid #CCCCCC;
    border-radius:5px;
    margin: 10px;
    height:300px;
  }
  .divHead{/*表格内的div的头部*/
    background-color: #CCCCCC;
    font-size: 20px;
    padding: 5px 0;
  }
  .pInCheck{
    display: block;
    font-size: 16px;
    text-align: left;
    margin-left: 30%;
  }
  .searchCard{/*搜索框*/
    margin:2% 0 1% 1%;
    padding: 0;
  }
  .mainTable tr:hover{
    background-color: #5cadff;
  }
  .paging{/*设置翻页*/
    display: block;
    margin-top:2%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// blindDetail.vue?79ecd9bd